import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Admission} from "./model";
import {firstValueFrom} from "rxjs";
import {NzCardModule} from "ng-zorro-antd/card";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzAlertModule} from "ng-zorro-antd/alert";
import {NzSkeletonModule} from "ng-zorro-antd/skeleton";
import {NzListModule} from "ng-zorro-antd/list";
import {AdmissionService} from './admission.service';
import {AdmissionCardComponent} from "./admission-card/admission-card.component";
import {NzEmptyModule} from 'ng-zorro-antd/empty';
import {endOfDay, isWithinInterval, startOfDay} from 'date-fns';
import {orderBy} from 'lodash-es';

@Component({
  selector: 'app-panel',
  standalone: true,
  imports: [CommonModule, NzCardModule, NzButtonModule, NzAlertModule, NzSkeletonModule,
    NzListModule, AdmissionCardComponent, NzEmptyModule],
  template: `
    @if (loading) {
      <nz-skeleton></nz-skeleton>
    } @else {
      @for (a of admissions; track a.conf_id) {
        <nz-card style="margin-top: 10px" [nzTitle]="a.variables?.title">
          <app-admission-card [admission]="a"></app-admission-card>
        </nz-card>
      } @empty {
        <div style="margin:10px;">
          <nz-alert [nzMessage]="noCommencementDate ? noCommencement : outOfApp"></nz-alert>
          <ng-template #outOfApp>
            <div>
              No application is available now. Please visit <a
              href="https://www.cityu.edu.hk/sro/">SRO home page</a> for the coming application period.
            </div>
          </ng-template>
          <ng-template #noCommencement>
            <div>
              Your commencement date is invalid, please contact <a href="mailto: sropga@cityu.edu.hk">SRO</a> to further
              enquire of your application procedure.
            </div>
          </ng-template>
        </div>
      }
    }
  `,
  styles: []
})
export class PanelComponent implements OnInit {

  admissions?: Admission[];
  loading = true;
  noCommencementDate = false;
  isTPG = (
    window.location.href.indexOf("P_MainTpg") > 1 ||
    window.location.href.indexOf("localhost") > 1 ||
    window.location.href.indexOf("hwhgapplctl_cityu.P_MainApp?p_mode=KLNT") > 1
  )

  constructor(private appl: AdmissionService) {
  }

  async ngOnInit(): Promise<void> {
    let allAdmissions = await firstValueFrom<any>(this.appl.getActiveAdmissions());
    // TODO - the admission should be grouped in some logic
    // console.log(allAdmissions);
    allAdmissions = orderBy(allAdmissions, 'parameters.application.start', 'desc');
    if (allAdmissions.length > 0) {
      this.noCommencementDate = allAdmissions.some((a: Admission) => !a.commencement_date);
      if (this.isTPG) {
        // TPG Processing
        allAdmissions = allAdmissions.filter((f: Admission) => {
          return f.round.startsWith("T");
        })
      } else {
        // RPG Processing
        allAdmissions = allAdmissions.filter((a: Admission) => {
          const {start, end} = a.parameters.commencement;
          const startDate = startOfDay(new Date(start));
          const endDate = endOfDay(new Date(end));
          const commencementDateInRange = isWithinInterval(a.commencement_date as any, {
            start: startDate, end: endDate
          });
          const hasResult = (!!a.application?.appl_decision) && a.application?.appl_decision != 'N';
          return (commencementDateInRange || hasResult) && !a.round.startsWith("T");
        });
      }
      
      if (allAdmissions.length > 0) {
        const applied = allAdmissions.filter((a: Admission) => !!a.application?.submitted_ref)
        this.admissions = applied.length > 0 ? [...applied] : (this.isTPG ? allAdmissions : [allAdmissions[0]]);
      } else {
        this.admissions = allAdmissions;
      }
    }
    this.loading = false
  }


}
